import { h as handle } from './index-B4g-ttS3.js';

var webhook = /*#__PURE__*/Object.freeze({
	__proto__: null,
	handle: handle
});

export { webhook as w };
